export type QueueTranslationFn = (
  key: string,
  options?: Record<string, unknown>,
) => string

export function formatWait(
  enqueuedAt: string | undefined,
  t: QueueTranslationFn,
): string {
  if (!enqueuedAt) return ''
  const secs = Math.floor((Date.now() - new Date(enqueuedAt).getTime()) / 1000)
  if (secs < 10) return t('weighbridgeOps.queue.waitJustNow')
  if (secs < 60) return t('weighbridgeOps.queue.waitSeconds', { secs })
  const mins = Math.floor(secs / 60)
  return t('weighbridgeOps.queue.waitMinutesSeconds', { mins, secs: secs % 60 })
}

export function formatWeight(
  kg: number | undefined,
  t: QueueTranslationFn,
): string {
  if (kg === undefined) return t('weighbridgeOps.queue.weightPending')
  return `${kg.toLocaleString()} kg`
}

export function getDisplayedWeight(
  primary?: number,
  fallback?: number | null,
): number | undefined {
  return primary ?? fallback ?? undefined
}

export function hasWeight(primary?: number, fallback?: number | null): boolean {
  return primary !== undefined || fallback != null
}

export function packagingIcon(packaging: 'bags' | 'bulk' | null | undefined): string {
  if (packaging === 'bags') return '📦'
  if (packaging === 'bulk') return '⬛'
  return '📦'
}
